import { render, staticRenderFns } from "./RelatorioContratoIj.vue?vue&type=template&id=734768aa&"
import script from "./RelatorioContratoIj.vue?vue&type=script&lang=js&"
export * from "./RelatorioContratoIj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports